import { instanceMainService } from 'primsell-shared-layer/api'
import { WrappedResponse, IRequestCreateOrder, IResponseCreateOrder } from 'primsell-shared-layer/types'
import { ORDER_URLS } from './order.constants'
import { replaceUrlParams } from '../../utils'

export class OrderAPI {
  static createOrder(payload: IRequestCreateOrder): Promise<WrappedResponse<IResponseCreateOrder>> {
    const { code, ...rest } = payload
    return instanceMainService.post(replaceUrlParams(ORDER_URLS.CREATE_ORDER, { code }), rest)
  }
}
